export default __webpack_public_path__ + "static/media/banner2.48bd09b9.jpg";